import { useEffect } from "react";

// Lightweight SEO: sets document title, meta description, canonical, and optional JSON-LD.
export default function SEO({ title, description, path = "", jsonLd }) {
  useEffect(() => {
    const full = title ? `${title} | Global Pass Consultants` : "Global Pass Consultants";
    document.title = full;

    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    setMeta("og:title", full, "property");
    setMeta("og:description", description, "property");

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
    canonical.href = `${window.location.origin}${path}`;

    let script = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!script) { script = document.createElement("script"); script.type = "application/ld+json"; script.id = "page-jsonld"; document.head.appendChild(script); }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
    window.scrollTo(0, 0);
  }, [title, description, path, jsonLd]);

  return null;
}
